export const ANALYTICS_QUEUE_KEY = "analytics_event_queue";
export const DEFAULT_LANDING_PAGE_CATEGORY = "General";

export const BACKEND_EVENTS: Set<string> = new Set([
  "success add slide",
  "success publish",
  "open pro dialog",
  "open team dialog",
  "click share",
  "success account activated",
  "click connect integration",
  "view automations page",
  "first publish",
  "view payments popup",
  "view popup team plan",
  "view payments",
  "click buy now",
  // Funnel 1: Trial → Paid
  "view compare plans dialog",
  "click compare plans plan",
  "click upgrade your workspace",
  "click select plan in trial banner",
  "click upgrade plan card",
  "click compare plans card",
  // Funnel 2: Cancel / Win-back
  "view cancel subscription dialog",
  "success cancel subscription",
  "failed cancel subscription",
  "click rejoin now",
  // Funnel 3: Team growth (signals already cover invite/delete user)
  "blocked add new user",
]);

export const LANDING_PAGE_CATEGORIES = new Map([
  [/^\/blog/, "Blog"],
  [/-template/, "Templates"],
  [/-slides/, "Slides"],
  [/\/proposal-maker/, "Proposal"],
  [/\/pitch-deck-templates/, "Pitch Deck"],
  [/\/presentation-maker/, "Presentation"],
  [/\/blog\/what-is-an-impact-report/, "Reports"],
  [/\/sign-up/, "Sign Up"],
  [/\/whitepaper-templates/, "Whitepaper"],
  [/\/case-study-creator/, "Case Study"],
  [/(creator|maker|software|tool)/gi, "Tools"],
]);

export const COOKIE_KEYS = {
  // Core wizard and user data
  DISTINCT_ID: "storydoc_distinct_id_67ebc42a-0835-47b9-9957-6cd8c3d02ef3",
  WIZARD_COOKIE_KEY: "storydoc_wizard_67ebc42a-0835-47b9-9957-6cd8c3d02ef3",
  DISTINCT_ID_COOKIE_KEY: "SD_DISTINCT_ID",

  // Authentication and verification
  INVITATION: "sd-invitation-link-data",
  VERIFICATION: "sd-verification-link-data",

  // Payment and checkout
  PADDLE_CHECKOUT: "sd_paddle_checkout",

  // Tracking and analytics
  GCLID: "storydoc_gclid",
  CID: "storydoc_cid",
  LANDING_PAGE: "storydoc_landing_page",
  WIZARD_ENVIRONMENT: "storydoc_wizardEnvironment",
  TESTING_NUMBER: "storydoc-testing-number",

  // UTM parameters prefix
  UTM_PREFIX: "storydoc_params_utm",
  PARAMS_PREFIX: "storydoc_params_",

  // Docpilot integration
  WIZARD_DOCPILOT: "storydoc_wizard_docpilot",
} as const;

export const WIZARD_DATA_KEYS = [
  "website",
  "isMobile",
  "industry",
  "testingNumber",
  "id",
] as const;
